import React, { Component } from "react";
import { connect, DispatchProp, Provider } from "react-redux";
import { BrowserRouter, Route, Router, Switch } from "react-router-dom";
import { GuardProvider, GuardedRoute } from "react-router-guards";
import Navigatable from "./components/Navigatable";

import Login from "./views/Login";
import store, { State } from "./store";
import { loginNeeded } from "./state/actions";
import SingleProduct from "./views/IDX/Components/SingleProduct";
import Resetpassword from "./views/IDX/Resetpassword";
import Register from "./views/IDX/Register";
import ContactUs from "./views/IDX/ContactUs";
import Createnewpassword from "./views/IDX/Createnewpassword";
import "react-loading-skeleton/dist/skeleton.css";
import Maps from "./views/IDX/Components/Maps";
import "react-loading-skeleton/dist/skeleton.css";
import "@coreui/coreui/dist/css/coreui.min.css";
import { PrivacyPolicy } from "./views/IDX/Pages/PrivacyPolicy";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "aos/dist/aos.css";
import "./assets/font/Roslindale_Web/fonts.css";
import "./assets/font/Secular/fonts.css";
import "./assets/font/Voyage/fonts.css";
import "./scss/idx.scss";
import "./scss/style.scss";
import "./scss/responsive.scss";
import Layoutidx from "./views/IDX/Routing/Layoutidx";
import LeadGeneration from "./views/IDX/Pages/LeadGeneration";
import Sharedoc from "./views/Transaction/Components/Sharedoc";
import { LeadBasePaint } from "./views/Transaction/Components/externalDocuments/LeadBasePaint";
import LeadinSoilAddendum from "./views/Transaction/Components/externalDocuments/LeadinsoilAddendum";
import SellerPdf from "./views/Transaction/Components/externalDocuments/SellerPdf";
import VAaddendum from "./views/Transaction/Components/externalDocuments/VAaddendum";
import LimitedDueagency from "./views/Transaction/Components/externalDocuments/ALALimitedDueagency";
import ALALimitedDueagency from "./views/Transaction/Components/externalDocuments/ALALimitedDueagency";
import ALAearlyoccupancy from "./views/Transaction/Components/externalDocuments/ALAearlyoccupancy";
import ALApersonelproperty from "./views/Transaction/Components/externalDocuments/ALApersonelproperty";
import FHAhomeinspection from "./views/Transaction/Components/externalDocuments/FHAhomeinspection";
import FHAclause from "./views/Transaction/Components/externalDocuments/FHAclause";
import ALApropertyinspection from "./views/Transaction/Components/externalDocuments/ALApropertyinspection";
import ALAreleasefrompurchase from "./views/Transaction/Components/externalDocuments/ALAreleasefrompurchase";
import ALAmultipleoffer from "./views/Transaction/Components/externalDocuments/ALAmultipleoffer";
import ALAsightunseen from "./views/Transaction/Components/externalDocuments/ALAsightunseen";
import ALAaddendumtopurchase from "./views/Transaction/Components/externalDocuments/ALAaddendumtopurchase";
import ALApostoccupancy from "./views/Transaction/Components/externalDocuments/ALApostoccupancy";
import ALAtidewater from "./views/Transaction/Components/externalDocuments/ALAtidewater";
import ViewAllPhotos from "./views/IDX/Components/ViewAllPhotos";
import ReqInspectionAuth from "./views/Transaction/Components/externalDocuments/ReqInspectionAuth";
import ReqPurchaseAggrement from "./views/Transaction/Components/externalDocuments/ReqPurchaseAggrement";
import ReqAffiliatedBusinessArrangement from "./views/Transaction/Components/externalDocuments/ReqAffiliatedBusinessArrangement";
import ReqAgencyDisclosure from "./views/Transaction/Components/externalDocuments/ReqAgencyDisclosure";
import ReqWireFraud from "./views/Transaction/Components/externalDocuments/ReqWireFraud";
import HomePage from "./views/IDX/HomePage";
import Magazine_Home from "./views/IDX/local/LocalHome";
import CondoGuide from "./views/IDX/buy/CondoGuide";
import BuyerGuide from "./views/IDX/buy/BuyerGuide";
import PrivateListings from "./views/IDX/buy/PrivateListings";
import BuyWithMilford from "./views/IDX/buy/BuyWithMilford";
import HomesForSale from "./views/IDX/buy/HomesForSale";
import TownhomesForSale from "./views/IDX/buy/TownhomesForSale";
import CondosForSale from "./views/IDX/buy/CondosForSale";
import LandForSale from "./views/IDX/buy/LandForSale";
import NewConstructionForSale from "./views/IDX/buy/NewConstructionForSale";
import AllHomesForSale from "./views/IDX/buy/AllHomesForSale";
import SellWithMilford from "./views/IDX/sell/SellWithMilford";
import WhatIsMyHomeWorth from "./views/IDX/sell/WhatIsMyHomeWorth";
import OurProcess from "./views/IDX/sell/OurProcess";
import SellerGuide from "./views/IDX/sell/SellerGuide";
import LocalHome from "./views/IDX/local/LocalHome";
import FullStory from "./views/IDX/local/stories/FullStory";
import Magazine from "./views/IDX/local/Magazine";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);
// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));
// const Layoutidx = React.lazy(() => import('./views/IDX/Routing/Layoutidx'));

type Props = {
  user: State["auth"]["user"];
} & DispatchProp;

class App extends Component<Props> {
  requireUser = (to: any, _from: any, next: any) => {
    if (to.meta.auth) {
      if (this.props.user) {
        next();
      } else {
        // this.props.dispatch(loginNeeded(window.location.pathname))
        next.redirect("/local");
      }
    } else {
      next();
    }
  };

  requirePublic = (_to: any, _from: any, next: any) => {
    if (!this.props.user) {
      next();
    } else {
      // next.redirect("/homepage");
      next.redirect("/local");
    }
  };

  requireIdxUser = (_to: any, _from: any, next: any) => {
    let user = localStorage.getItem("user");
    let user_id = user ? JSON.parse(user) : null;
    if (user_id?.id) {
      next();
    } else {
      next.redirect("/login");
    }
  };

  render() {
    return (
      // <Provider store={Datastore}>

      <BrowserRouter>
        <Navigatable>
          <React.Suspense fallback={loading}>
            <GuardProvider>
              <Switch>
                <GuardedRoute path="/register" component={Register} />
                <GuardedRoute path="/contactus" component={ContactUs} />
                <GuardedRoute path="/signdoc" component={Sharedoc} />
                {/* documents start */}
                {/* seller agent start */}
                <GuardedRoute
                  path="/document=LeadBasedPaint/:id/:user"
                  component={LeadBasePaint}
                  meta={{ auth: false }}
                />
                <GuardedRoute
                  path="/document=leadandsoiladdendum/:id/:user"
                  component={LeadinSoilAddendum}
                  meta={{ auth: false }}
                />
                <GuardedRoute
                  path="/document=sellerpropertydisclosure/:id/:user"
                  component={SellerPdf}
                  meta={{ auth: false }}
                />
                {/* seller agent end */}
                {/* VA addendum start */}
                <GuardedRoute
                  path="/document=VAaddendum/:id/:user"
                  component={VAaddendum}
                />
                {/* VA addendum end */}
                {/* FHA doc start */}
                <GuardedRoute
                  path="/document=foryourprotectiongettingyourhomeinspection/:id/:user"
                  component={FHAhomeinspection}
                />
                <GuardedRoute
                  path="/document=fhaclauseandrealestatecertification/:id/:user"
                  component={FHAclause}
                />
                {/* FHA doc end */}
                {/* A LA carte doc start */}
                <GuardedRoute
                  path="/document=limiteddualagencyagreement/:id/:user"
                  component={ALALimitedDueagency}
                />
                <GuardedRoute
                  path="/document=personalpropertybillofsale/:id/:user"
                  component={ALApersonelproperty}
                />
                <GuardedRoute
                  path="/document=earlyoccupancyagreement/:id/:user"
                  component={ALAearlyoccupancy}
                />
                <GuardedRoute
                  path="/document=piapropertyinspectionresolutionaddendum/:id/:user"
                  component={ALApropertyinspection}
                />
                <GuardedRoute
                  path="/document=releasefrompurchaseagreement/:id/:user"
                  component={ALAreleasefrompurchase}
                />
                <GuardedRoute
                  path="/document=multipleofferaddendum/:id/:user"
                  component={ALAmultipleoffer}
                />
                <GuardedRoute
                  path="/document=sightunseenaddendum/:id/:user"
                  component={ALAsightunseen}
                />
                <GuardedRoute
                  path="/document=addendumtopurchaseagreement/:id/:user"
                  component={ALAaddendumtopurchase}
                />
                <GuardedRoute
                  path="/document=postoccupancyagreement/:id/:user"
                  component={ALApostoccupancy}
                />
                <GuardedRoute
                  path="/document=tidewaterva/:id/:user"
                  component={ALAtidewater}
                />

                {/* required docs */}
                <GuardedRoute
                  path="/document=purchaseagreement/:id/:user"
                  component={ReqPurchaseAggrement}
                  meta={{ auth: false }}
                />
                <GuardedRoute
                  path="/document=inspectionauthorization/:id/:user"
                  component={ReqInspectionAuth}
                  meta={{ auth: false }}
                />
                <GuardedRoute
                  path="/document=affiliatedbusinessarrangement/:id/:user"
                  component={ReqAffiliatedBusinessArrangement}
                  meta={{ auth: false }}
                />
                <GuardedRoute
                  path="/document=agencydisclosure&trustedvendor/:id/:user"
                  component={ReqAgencyDisclosure}
                  meta={{ auth: false }}
                />
                <GuardedRoute
                  path="/document=wirefraud/:id/:user"
                  component={ReqWireFraud}
                  meta={{ auth: false }}
                />
                {/* ALA carte end */}
                {/* documents end */}
                <GuardedRoute
                  path="/view-all-photos"
                  component={ViewAllPhotos}
                />
                <GuardedRoute
                  path="/singleproduct/:id"
                  component={SingleProduct}
                />
                <GuardedRoute
                  path="/forgotpassword"
                  component={Resetpassword}
                />
                <GuardedRoute
                  path="/buyer/find-the-home-that-speaks-to-you"
                  component={LeadGeneration}
                />
                <GuardedRoute
                  path="/resetpassword"
                  component={Createnewpassword}
                />
                <GuardedRoute
                  path="/login"
                  component={Login}
                  guards={[this.requirePublic]}
                />
                <GuardedRoute
                  path="/property-list"
                  component={Layoutidx}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/maps/:type"
                  component={Maps}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/homepage"
                  component={HomePage}
                  meta={{ auth: true }}
                />
                {/* vs New Route created  */}
                <GuardedRoute
                  path="/buy/houses-for-sale/"
                  component={HomesForSale}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/buy/townhouses-for-sale/"
                  component={TownhomesForSale}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/buy/condos-for-sale/"
                  component={CondosForSale}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/buy/land-for-sale/"
                  component={LandForSale}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/buy/new-construction-for-sale/"
                  component={NewConstructionForSale}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/buy/all-homes-for-sale/"
                  component={AllHomesForSale}
                  meta={{ auth: true }}
                />

                <GuardedRoute
                  path="/buy/buy-with-milford/"
                  component={BuyWithMilford}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/buy/private-listings/"
                  component={PrivateListings}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/buy/buyer-guide/"
                  component={BuyerGuide}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/buy/condo-guide/"
                  component={CondoGuide}
                  meta={{ auth: true }}
                />

                <GuardedRoute
                  path="/sell/sell-with-milford"
                  component={SellWithMilford}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/sell/what-is-my-home-worth/"
                  component={WhatIsMyHomeWorth}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/sell/our-process/"
                  component={OurProcess}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/sell/seller-guide/"
                  component={SellerGuide}
                  meta={{ auth: true }}
                />
                <GuardedRoute
                  path="/magazine"
                  component={Magazine}
                  meta={{ auth: true }}
                />

                <GuardedRoute path="/local/*" component={FullStory} />

                {/* <GuardedRoute path="/local/:slug" component={FullStory} /> */}
                <GuardedRoute
                  path="/local"
                  component={LocalHome}
                  meta={{ auth: true }}
                />

                <GuardedRoute
                  path="/"
                  component={TheLayout}
                  meta={{ auth: true }}
                  guards={[this.requireUser]}
                />
                <GuardedRoute
                  path="/leads"
                  component={TheLayout}
                  meta={{ auth: true }}
                  guards={[this.requireUser]}
                />
              </Switch>
            </GuardProvider>
          </React.Suspense>
        </Navigatable>
      </BrowserRouter>
      /* */
    );
  }
}
export default connect((state: State) => ({
  user: state.auth.user,
}))(App);
